import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import ListItem              from '@material-ui/core/ListItem'
import Slide                 from '@material-ui/core/Slide'
import { Theme, withStyles } from '@material-ui/core/styles'
import Typography            from '@material-ui/core/Typography'

import testingHooks      from '../../testing-hooks'
import { AppBarSpacing } from '../atoms/index'

const styles = (theme: Theme) => ({
  main: {
    overflow: 'auto',
    padding:  theme.spacing.unit * 2,
    height:   'calc(100vh - 112px)',

    [ theme.breakpoints.up('sm') ]: {
      height:  'calc(100vh - 184px)',
      padding: theme.spacing.unit * 3,
    },
  },
})

interface Props {
  title: string
  component: any
}

export default withStyles(styles)<Props>(
  ({ title, component: Component, classes }) => {
    return (
      <>
        <AppBarSpacing>
          {({ className }) => (
            <ListItem
              divider
              className={className}
            >
              <Typography
                variant={'title'}
                data-test-id={testingHooks.mainAreaTitle}
              >
                <FormattedMessage id={'routing.' + title} />
              </Typography>
            </ListItem>
          )}
        </AppBarSpacing>
        <div className={classes.main}>
          <Slide direction={'up'} appear in>
            <div>
              <Component />
            </div>
          </Slide>
        </div>
      </>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/templates/MainArea.tsx